"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
var InputLabel_1 = __importDefault(require("@mui/material/InputLabel"));
var defaultProps_1 = __importDefault(require("./defaultProps"));
var makeInputLabelStyles_1 = __importDefault(require("./makeInputLabelStyles"));
var InputLabel = function (_a) {
    var children = _a.children, isAnswered = _a.isAnswered, experimentName = _a.experimentName, otherProps = __rest(_a, ["children", "isAnswered", "experimentName"]);
    return ((0, jsx_runtime_1.jsx)(InputLabel_1.default, __assign({ css: (0, makeInputLabelStyles_1.default)({ isAnswered: isAnswered }) }, otherProps, { children: children })));
};
InputLabel.defaultProps = defaultProps_1.default;
exports.default = InputLabel;
//# sourceMappingURL=InputLabel.js.map